/* eslint-disable */
import React, { useState, useContext, useEffect } from 'react';
import { FormGroup } from 'react-bootstrap';

import { Context } from 'context/AuthContext';
import SingleSelect from 'components/_base/SelectSingle';

import './styles.scss';

const FiltroExtrato = (props) => {
  const { showLoader } = useContext(Context);

  const [anosList, setAnosList] = useState([]);
  const [mesList, setMesList] = useState([]);
  const [dadosFiltro, setDadosFiltro] = useState({});

  const { regionais } = props;
  // setRegionalList(regionais);

  function getYears() {
    const date = new Date();
    const inicio = 2017;
    const fim = date.getFullYear();
    const options = [];

    for (let i = inicio; i <= fim; i++) {
      options.push({ value: i, label: i });
    }
    return options;
  }

  function getMonths() {
    const date = new Date();
    const inicio = 1;
    let fim = 12;
    const options = [];

    if (dadosFiltro.ano === date.getFullYear()) {
      fim = date.getMonth() + 1;
    }

    const mesNomes = [
      '',
      'janeiro',
      'fevereiro',
      'março',
      'abril',
      'maio',
      'junho',
      'julho',
      'agosto',
      'setembro',
      'outubro',
      'novembro',
      'dezembro',
    ];

    for (let i = inicio; i <= fim; i++) {
      options.push({ value: i, label: mesNomes[i] });
    }
    return options;
  }

  useEffect(() => {
    (async () => {
      showLoader(true);

      const anos = getYears();
      setAnosList(anos);

      const meses = getMonths();
      setMesList(meses);

      props.onSelect(dadosFiltro);

      showLoader(false);
    })();
  }, [dadosFiltro]);

  useEffect(() => {
    (async () => {
      const dtHoje = new Date();
      dtHoje.setMonth(dtHoje.getMonth() - 1);

      const mes = dtHoje.getMonth() + 1;
      const ano = dtHoje.getFullYear();

      setDadosFiltro({
        ...dadosFiltro,
        mes,
        ano,
      });
    })();
  }, []);

  async function onChangeWithName(value, name) {
    setDadosFiltro({
      ...dadosFiltro,
      [name]: value,
    });
  }

  return (
    <div className="filtro-extrato">
      <FormGroup className="row">
        <label className="col-md-1 col-form-label text-md-right">Ano</label>
        <div className="col-md-2">
          <SingleSelect
            value={dadosFiltro.ano}
            name="ano"
            onChange={onChangeWithName}
            options={anosList}
          />
        </div>
        <label className="col-md-1 col-form-label text-md-right">Mês</label>
        <div className="col-md-2">
          <SingleSelect
            value={dadosFiltro.mes}
            name="mes"
            onChange={onChangeWithName}
            options={mesList}
          />
        </div>
        <label className="col-md-1 col-form-label text-md-right">
          Regional
        </label>
        <div className="col-md-4">
          <SingleSelect
            isClearable
            value={dadosFiltro.regionalId}
            name="regionalId"
            onChange={onChangeWithName}
            options={regionais}
          />
        </div>
      </FormGroup>
    </div>
  );
};

export default FiltroExtrato;
